import SideBar from "../components/sideBar";
import translateText, { currentLanguage } from "../signals/language.signal";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import { primaryFount } from "../signals/Theme colors.signal";
import CouponDetails from "./couponsDetails";
import { Link } from "react-router-dom";
import { signalPagePath } from "../signals/login.signal";
import {
  PropCouponColor,
  PropCouponTypeData,
  couponsType,
  fetchCoupons,
} from "../signals/couponsData.signal";
import { useEffect, useState } from "react";
import { getCurrencySymbol } from "../components/CurrencySymbol";
const Coupon = () => {
  const [details, setDetails] = useState(null);
  useEffect(() => {
    // couponsType.value = "";
    const fetchData = async () => {
      try {
        const result = await fetchCoupons();
        couponsType.value = result;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  const colors = ["#ff9c6b", "#2ba56c", "#f1727e", "#76a3c5"];
  return (
    <>
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "Coupon")}
      />

      <div
        id="loginPage"
        className="flex-column gap-3 align-items-sm-center d-flex justify-content-center w-100 p-3"
      >
        {couponsType.value ? (
          couponsType.value.length > 0 ? (
            couponsType.value.map((data, index) => (
              <Link
                key={index}
                className=" loginContaner position-relative mb-1 p-2 border w-100   rounded-3 "
                style={{
                  background: colors[index],
                  color: primaryFount.value,
                }}
                to={signalPagePath.value ? "/CouponDetails" : "/"}
                onClick={() => {
                  PropCouponTypeData.value = data.PROMOTYPE;
                  PropCouponColor.value = colors[index];
                  setDetails(data.DISCOUNT);
                  window.scrollTo(0, 0);
                }}
              >
                <div className="w-100 d-flex">
                  <div
                    className="position-absolute rounded-circle"
                    style={{
                      background: "#fbfbfb",
                      height: "30px",
                      width: "30px",
                      transform: "translate(calc(100% + -45px), 50%)",
                      left: "0",
                    }}
                  ></div>
                  <div className="d-flex flex-column align-items-center p-1 ms-3 me-3">
                    <p className="m-0 ">
                      {"X "}
                      {data.NUMOFPROMOCODE}
                    </p>
                    <CardGiftcardIcon
                      className="  m-0 "
                      style={{ fontSize: "55px" }}
                    />
                  </div>
                  <div
                    className="w-auto h-auto border-1 "
                    style={{ border: "dashed" }}
                  ></div>
                  <div
                    className=" w-100 d-flex flex-column justify-content-center ms-3 me-3"
                    onClick={() => {
                      setDetails(data.PROMOTYPE);
                    }}
                  >
                    <p className="m-0 ">
                      {translateText(currentLanguage.value, "Balance")}
                    </p>
                    <p
                      className="form-label  "
                      style={{
                        fontSize: "30px",
                        margin: "0",
                        width: "fit-content",
                      }}
                      dir="ltr"
                    >
                      {getCurrencySymbol(primaryFount.value)}
                      {data.DISCOUNT}
                    </p>
                    <p className="m-0 " style={{ fontSize: "12px" }}>
                      {data.PROMOTYPEDESC}{" "}
                      {translateText(currentLanguage.value, "invoiceValue")}
                    </p>
                  </div>
                  <div
                    className="position-absolute rounded-circle"
                    style={{
                      background: "#fbfbfb",
                      height: "30px",
                      width: "30px",
                      transform: "translate(calc(100% + -15px), 50%)",
                      right: "0",
                    }}
                  ></div>
                </div>
              </Link>
            ))
          ) : (
            <>
              <div className="loginContaner bg-white p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
                <h5>Coupons not found</h5>
              </div>
            </>
          )
        ) : (
          <>
            {[1, 2, 3].map((index) => (
              <div
                key={index}
                className="align-items-sm-center d-flex justify-content-center w-100 mb-1"
              >
                <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
                  <div
                    style={{ height: "228.88px" }}
                    className="skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
                  ></div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
      {details ? <CouponDetails PropCouponTypeData={details} /> : null}
    </>
  );
};
export default Coupon;
